var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "container-fluid relative" }, [
      _c("section", { staticClass: "mw7 relative z-1 center pt4 pt5-ns" }, [
        _c("div", { staticClass: "tc" }, [
          _c(
            "h1",
            { staticClass: "page-title pt4 is-gravitas-important ttu" },
            [_vm._v(_vm._s(_vm.post.title))]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "absolute z-0 mw4 mw5-ns topography topography-top-left-wrap"
        },
        [
          _c("simple-svg", {
            attrs: {
              filepath: "/assets/images/svg/gdz18-topography.svg",
              id: "topography-top-left"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid relative" }, [
      _c(
        "section",
        { staticClass: "mw7 relative z-1 center pv3 pv4-ns is-navy" },
        [
          _c("div", { staticClass: "row middle-sm" }, [
            _vm.post["Featured Image"]
              ? _c("div", { staticClass: "col-xs-12 col-sm-4" }, [
                  _c("img", {
                    staticClass: "db center content-image",
                    attrs: { src: _vm.post["Featured Image"] }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", {
              staticClass: "col-xs-12 col-sm-8 center",
              domProps: { innerHTML: _vm._s(_vm.post.content) }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dn db-ns bg plus-signs z-0" })
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }